import { render, staticRenderFns } from "./ProjectTypeCspKpi.vue?vue&type=template&id=38f15b9e&scoped=true"
import script from "./ProjectTypeCspKpi.vue?vue&type=script&lang=ts"
export * from "./ProjectTypeCspKpi.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTypeCspKpi.vue?vue&type=style&index=0&id=38f15b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f15b9e",
  null
  
)

export default component.exports